import { createFileRoute } from '@tanstack/react-router'
import CardView from '@/components/shared/CardView'

export const Route = createFileRoute('/card-template')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <CardView />
      </div>
    </div>
  )
}
